import { api } from "@/lib/api/axios";
import { RelacaoPagamentos, RelacaoPagamentosGetResponse } from "./payments.type";

const PAYMENTS_API_PATH = '/payments';

export const paymentsService = {
  uploadNF: async (file: FormData, contractId: number) => {
    return api.post<{ url: string }>(`${PAYMENTS_API_PATH}/upload-nf/${contractId}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  save: async (data: RelacaoPagamentos) => {
    return api.post(`${PAYMENTS_API_PATH}`, data);
  },

  update: async (id: number, data: Partial<RelacaoPagamentos>) => {
    return api.patch(`${PAYMENTS_API_PATH}/${id}`, data);
  },

  findAllByMovieId: async (movieId: number) => {
    return api.get<RelacaoPagamentosGetResponse[]>(`${PAYMENTS_API_PATH}/movie/${movieId}`);
  }
};
